









































































import { Component, Vue, Prop, Ref } from "vue-property-decorator";

@Component
export default class ImageLightbox extends Vue {
    @Prop({ required: true }) images!: Image[];

    @Ref("imageHolder") readonly imageHolder!: HTMLDivElement;

    isOpen: boolean = false;

    viewingId: number | false = false;

    open(id: number) {
        if (!id && this.images) {
            this.viewingId = this.images[0].id;
        } else {
            this.viewingId = id;
        }

        this.isOpen = true;
        // @ts-ignore
        this.$root.disableScrolling(true);

        this.$nextTick(() => {
            const sliderImage: HTMLElement = this.imageHolder.querySelector(`#silder-image-${this.viewingId}`) as HTMLElement;
            const offset: number = sliderImage?.offsetTop || 0;
            this.imageHolder.scrollTo({ top: offset });
        });
    }

    close() {
        this.isOpen = false;
        // @ts-ignore
        this.$root.disableScrolling(false);
    }
}
